import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, StarIcon, CheckCircleIcon, ShieldIcon } from 'lucide-react';
export function HeroSection() {
  return <section style={{
    backgroundColor: '#F5EDE4'
  }} data-id="element-72">
      {/* MOBILE LAYOUT: image on top, text below (unchanged) */}
      <div className="block md:hidden" data-id="element-73">
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6
      }} className="relative w-full" data-id="element-74">
          <img src="https://cdn.magicpatterns.com/uploads/rZKRMiYtZpATgnJMp1SqhQ/ChatGPT_Image_27_mar_2026,_07_05_39_p.m..png" alt="Emely con Cinnamon Rolls XL y libro Estilo New York" className="w-full object-cover" style={{
          maxHeight: '70vh',
          display: 'block'
        }} data-id="element-75" />
          <div className="absolute bottom-0 left-0 right-0" style={{
          height: '40%',
          background: 'linear-gradient(to top, #F5EDE4, transparent)'
        }} data-id="element-76" />
        </motion.div>

        <div className="max-w-4xl mx-auto px-4 pt-6 pb-14 text-center" data-id="element-77">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7
        }} data-id="element-78">
            <span className="inline-block text-xs font-bold tracking-[0.25em] uppercase mb-4" style={{
            color: '#e76f51'
          }} data-id="element-79">
              EDICIÓN COLECCIONABLE
            </span>

            <h1 className="mb-4 leading-[1.15]" data-id="element-80">
              <span className="block text-2xl italic mb-3" style={{
              color: '#5a5248',
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-81">
                "El cinnamon roll siempre ha sido delicioso…
              </span>
              <span className="block text-2xl font-bold" style={{
              color: '#1A1614'
            }} data-id="element-82">
                pero hoy puede ser mucho más que un postre."
              </span>
            </h1>

            <p className="text-base mb-6" style={{
            color: '#5a5248'
          }} data-id="element-83">
              Descubre cómo convertir un clásico al formato XL estilo New York
              viral.
            </p>

            <div className="flex flex-col items-center gap-2 mb-6" data-id="element-84">
              <div className="flex items-center gap-2" data-id="element-85">
                <div className="flex items-center gap-0.5" data-id="element-86">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-87" />)}
                </div>
                <span className="text-sm font-bold" style={{
                color: '#1A1614'
              }} data-id="element-88">
                  Más de +998 Alumnos Felices
                </span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-89">
                <CheckCircleIcon className="w-4 h-4" style={{
                color: '#07c86e'
              }} data-id="element-90" />
                <span className="text-sm font-medium" style={{
                color: '#07c86e'
              }} data-id="element-91">
                  Verificado
                </span>
              </div>
            </div>

            <div className="flex flex-col items-center gap-3" data-id="element-92">
              <button onClick={() => document.getElementById('producto')?.scrollIntoView({
              behavior: 'smooth'
            })} className="inline-flex items-center gap-3 font-bold text-base py-4 px-8 rounded-full transition-all duration-300 w-full sm:w-auto justify-center" style={{
              backgroundColor: '#e76f51',
              color: '#ffffff',
              boxShadow: '0 4px 24px rgba(231,111,81,0.3)'
            }} onMouseEnter={e => {
              e.currentTarget.style.backgroundColor = '#f08565';
              e.currentTarget.style.transform = 'scale(1.02)';
            }} onMouseLeave={e => {
              e.currentTarget.style.backgroundColor = '#e76f51';
              e.currentTarget.style.transform = 'scale(1)';
            }} data-id="element-93">
                Quiero descubrir los Cinnamon Rolls XL
                <ArrowRightIcon className="w-5 h-5" data-id="element-94" />
              </button>
              <span className="text-xs flex items-center gap-2" style={{
              color: '#5a5248'
            }} data-id="element-95">
                <ShieldIcon className="w-4 h-4" data-id="element-96" /> Garantía 7 días · Descarga
                inmediata
              </span>
            </div>
          </motion.div>
        </div>
      </div>

      {/* DESKTOP/TABLET LAYOUT: text left, image right */}
      <div className="hidden md:flex items-center max-w-7xl mx-auto px-6 lg:px-12 py-16 lg:py-24 gap-10 lg:gap-16" data-id="element-97">
        {/* Left: Text content */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.7
      }} className="flex-1 min-w-0" data-id="element-98">
          <span className="inline-block text-xs font-bold tracking-[0.25em] uppercase mb-6" style={{
          color: '#e76f51'
        }} data-id="element-99">
            EDICIÓN COLECCIONABLE
          </span>

          <h1 className="mb-6 leading-[1.15]" data-id="element-100">
            <span className="block text-3xl lg:text-4xl italic mb-4" style={{
            color: '#5a5248',
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-101">
              "El cinnamon roll siempre ha sido delicioso…
            </span>
            <span className="block text-3xl lg:text-5xl font-bold" style={{
            color: '#1A1614'
          }} data-id="element-102">
              pero hoy puede ser mucho más que un postre."
            </span>
          </h1>

          <p className="text-xl lg:text-2xl mb-8" style={{
          color: '#5a5248'
        }} data-id="element-103">
            Descubre cómo convertir un clásico al formato XL estilo New York
            viral.
          </p>

          <div className="flex flex-col items-start gap-2 mb-8" data-id="element-104">
            <div className="flex items-center gap-2" data-id="element-105">
              <div className="flex items-center gap-0.5" data-id="element-106">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-107" />)}
              </div>
              <span className="text-sm font-bold" style={{
              color: '#1A1614'
            }} data-id="element-108">
                Más de +998 Alumnos Felices
              </span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-109">
              <CheckCircleIcon className="w-4 h-4" style={{
              color: '#07c86e'
            }} data-id="element-110" />
              <span className="text-sm font-medium" style={{
              color: '#07c86e'
            }} data-id="element-111">
                Verificado
              </span>
            </div>
          </div>

          <div className="flex flex-col gap-3 items-center justify-center" data-id="element-112">
            <button onClick={() => document.getElementById('producto')?.scrollIntoView({
            behavior: 'smooth'
          })} className="inline-flex items-center gap-3 font-bold text-lg py-5 px-10 rounded-full transition-all duration-300" style={{
            backgroundColor: '#e76f51',
            color: '#ffffff',
            boxShadow: '0 4px 24px rgba(231,111,81,0.3)'
          }} onMouseEnter={e => {
            e.currentTarget.style.backgroundColor = '#f08565';
            e.currentTarget.style.transform = 'scale(1.02)';
          }} onMouseLeave={e => {
            e.currentTarget.style.backgroundColor = '#e76f51';
            e.currentTarget.style.transform = 'scale(1)';
          }} data-id="element-113">
              Quiero descubrir los Cinnamon Rolls XL
              <ArrowRightIcon className="w-5 h-5" data-id="element-114" />
            </button>
            <span className="text-sm flex gap-2 items-center justify-center" style={{
            color: '#5a5248'
          }} data-id="element-115">
              <ShieldIcon className="w-4 h-4" data-id="element-116" /> Garantía 7 días · Descarga
              inmediata
            </span>
          </div>
        </motion.div>

        {/* Right: Image */}
        <motion.div initial={{
        opacity: 0,
        x: 30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.7,
        delay: 0.15
      }} className="flex-1 min-w-0 relative" data-id="element-117">
          <img src="https://cdn.magicpatterns.com/uploads/rZKRMiYtZpATgnJMp1SqhQ/ChatGPT_Image_27_mar_2026,_07_05_39_p.m..png" alt="Emely con Cinnamon Rolls XL y libro Estilo New York" className="w-full h-auto rounded-3xl shadow-2xl object-cover" style={{
          maxHeight: '75vh'
        }} data-id="element-118" />
        </motion.div>
      </div>
    </section>;
}